module.exports = __webpack_public_path__ + "img/Mayra_Rodriguez.4292b39a.jpg";